var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44211 12.0575C7.46711 11.0825 6.73211 9.99083 6.24378 8.88333C6.14128 8.64916 6.20128 8.37499 6.38211 8.19416L7.06461 7.51166C7.62378 6.95249 7.62378 6.16166 7.13545 5.67333L6.15795 4.69583C5.50711 4.04499 4.45211 4.04499 3.80128 4.69583L3.25795 5.23833C2.64045 5.85583 2.38295 6.74666 2.54961 7.62999C2.96128 9.80749 4.22628 12.1917 6.26711 14.2325C8.30795 16.2733 10.6921 17.5383 12.8696 17.95C13.7529 18.1167 14.6438 17.8592 15.2613 17.2417L15.8038 16.6992C16.4546 16.0483 16.4546 14.9933 15.8038 14.3425L14.8263 13.365C14.3379 12.8767 13.5463 12.8767 13.0588 13.365L12.3063 14.1183C12.1254 14.2992 11.8513 14.36 11.6171 14.2567C10.5096 13.7675 9.41711 13.0317 8.44211 12.0575Z",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8V3H12.5",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8L17.5 3",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ebc9c0ba00946e2be17167a7d25707e4.svg";
export { ForwardRef as ReactComponent };